// extracted by mini-css-extract-plugin
export default {"wrap":"Gallery_wrap__J6RAk","embla":"Gallery_embla__7EZVe","slides":"Gallery_slides__Sd-dc","slide":"Gallery_slide__xvYjW"};